import React, { useState } from 'react';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { UploadIcon, ImageIcon, CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function VideoUpload() {
  const navigate = useNavigate();
  const [uploadedFile, setUploadedFile] = useState<string | null>(null);
  const [detectedDimensions, setDetectedDimensions] = useState<string | null>(null);
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFile(URL.createObjectURL(file));
      setDetectedDimensions('1080 x 1080 (1:1)');
    }
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1688">
      <Sidebar data-id="element-1689" />
      <main className="flex-1" data-id="element-1690">
        <Header data-id="element-1691" />
        <div className="px-6 py-8" data-id="element-1692">
          <div className="max-w-4xl mx-auto" data-id="element-1693">
            <div className="mb-6" data-id="element-1694">
              <button onClick={() => navigate('/creative-customizer')} className="text-sm text-blue-500 hover:text-blue-600 mb-2 transition-colors" data-id="element-1695">
                ← Back to Creative Customizer
              </button>
              <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1696">
                Image to Video Generator
              </h1>
              <p className="text-gray-600" data-id="element-1697">
                Transform static images into professional video ads
              </p>
            </div>

            {!uploadedFile ? <div className="bg-white rounded-lg border border-gray-200 p-12" data-id="element-1698">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center hover:border-gray-400 transition-colors" data-id="element-1699">
                  <UploadIcon className="mx-auto text-gray-400 mb-4" size={64} data-id="element-1700" />
                  <h3 className="text-lg font-medium text-gray-700 mb-2" data-id="element-1701">
                    Upload Product Image
                  </h3>
                  <p className="text-sm text-gray-500 mb-6" data-id="element-1702">
                    Upload a static product image to convert to video
                  </p>
                  <label className="inline-block bg-blue-500 text-white px-8 py-3 rounded-md cursor-pointer hover:bg-blue-600 font-medium transition-colors" data-id="element-1703">
                    Choose Image
                    <input type="file" className="hidden" accept="image/*" onChange={handleFileUpload} data-id="element-1704" />
                  </label>
                  <p className="text-xs text-gray-500 mt-4" data-id="element-1705">
                    Supports JPG, PNG • Maximum 10MB
                  </p>
                </div>

                <div className="mt-8 bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-1706">
                  <h4 className="font-medium text-green-900 mb-3" data-id="element-1707">
                    AI Video Features
                  </h4>
                  <div className="grid grid-cols-2 gap-4 text-sm text-green-800" data-id="element-1708">
                    <div data-id="element-1709">
                      <p className="font-medium mb-1" data-id="element-1710">• Product Animation</p>
                      <p className="text-xs" data-id="element-1711">
                        3D rotation, zoom, and movement effects
                      </p>
                    </div>
                    <div data-id="element-1712">
                      <p className="font-medium mb-1" data-id="element-1713">• Camera Motion</p>
                      <p className="text-xs" data-id="element-1714">
                        Cinematic panning and parallax effects
                      </p>
                    </div>
                    <div data-id="element-1715">
                      <p className="font-medium mb-1" data-id="element-1716">• Text Animations</p>
                      <p className="text-xs" data-id="element-1717">Smooth fade in/out transitions</p>
                    </div>
                    <div data-id="element-1718">
                      <p className="font-medium mb-1" data-id="element-1719">• Duration</p>
                      <p className="text-xs" data-id="element-1720">
                        4-8 seconds (optimized for social)
                      </p>
                    </div>
                  </div>
                </div>
              </div> : <div className="space-y-6" data-id="element-1721">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1722">
                  <div className="flex items-center justify-between mb-4" data-id="element-1723">
                    <h3 className="font-medium text-gray-800" data-id="element-1724">
                      Uploaded Image
                    </h3>
                    <CheckCircleIcon className="text-green-500" size={24} data-id="element-1725" />
                  </div>
                  <div className="flex items-center space-x-6" data-id="element-1726">
                    <div className="w-48 h-48 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1727">
                      <ImageIcon className="text-gray-400" size={64} data-id="element-1728" />
                    </div>
                    <div className="flex-1" data-id="element-1729">
                      <p className="font-medium text-gray-800 mb-2" data-id="element-1730">
                        Product Image
                      </p>
                      <div className="space-y-2 text-sm" data-id="element-1731">
                        <div className="flex items-center" data-id="element-1732">
                          <span className="text-gray-600 w-32" data-id="element-1733">
                            Dimensions:
                          </span>
                          <span className="font-medium text-gray-800" data-id="element-1734">
                            {detectedDimensions}
                          </span>
                        </div>
                        <div className="flex items-center" data-id="element-1735">
                          <span className="text-gray-600 w-32" data-id="element-1736">Format:</span>
                          <span className="font-medium text-gray-800" data-id="element-1737">
                            Image
                          </span>
                        </div>
                      </div>
                      <button onClick={() => {
                    setUploadedFile(null);
                    setDetectedDimensions(null);
                  }} className="text-sm text-blue-500 mt-4 hover:text-blue-600 transition-colors" data-id="element-1738">
                        Change image
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-1739">
                  <h4 className="font-medium text-green-900 mb-2" data-id="element-1740">
                    Ready for Video Generation
                  </h4>
                  <p className="text-sm text-green-800" data-id="element-1741">
                    Your image has been analyzed. Continue to configure video
                    settings and animations.
                  </p>
                </div>

                <div className="flex justify-between" data-id="element-1742">
                  <button onClick={() => navigate('/creative-customizer')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1743">
                    Cancel
                  </button>
                  <button onClick={() => navigate('/dealer/video-generator/configure')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1744">
                    Continue to Configuration
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}